module.exports = __webpack_public_path__ + "static/media/warning-sm-18.fe656eb6.svg";